import { extendTheme } from "native-base";

import colors from './colors'
import fonts from "./fonts";

export default extendTheme({
    config: {
      initialColorMode: "light",
    },
    colors: colors,
    fonts: fonts
  });